export default __webpack_public_path__ + "static/media/switch2.d3e7ebd6.svg";